import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';

import { User, USER_ROLE } from '../models';

@Injectable({
  providedIn: 'root',
})
export class CurrentUserService {
  // TODO: replace with the real user store once partner-dashboard has auth.
  // The dashboard equivalent is UserStoreService (@rms/user) -> user$.full_name.
  public readonly user$: Observable<User> = of({
    id: '1224',
    full_name: 'Partner User',
    email: 'j.smith@romulus.live',
    organization_id: '222133213',
    roles: [USER_ROLE.ROLE_SUPERVISOR],
  });
}
